import React from 'react';
import { Descriptions } from 'antd';
import PropTypes from 'prop-types';
import { DateDisplay } from '../../../../layout';

const Content = ({ answer, questionType, options }) => {
  switch (questionType) {
    case 'TEXT':
      return answer;
    case 'RADIO':
      return options.find(({ value }) => value === answer).label;
    default:
      break;
  }
};

const ReportReviewDetail = ({ detail, completedBy, date }) => {
  const { netId, name } = completedBy;

  return (
    <Descriptions column={1}>
      <Descriptions.Item label="Completed By">
        {`${name} (${netId})`}
      </Descriptions.Item>
      <Descriptions.Item label="Date">
        <DateDisplay date={date} />
      </Descriptions.Item>
      {detail.map(
        ({ question, questionText, answer, questionType, options }) => (
          <Descriptions.Item label={questionText} key={question}>
            <Content
              answer={answer}
              questionType={questionType}
              options={options}
            />
          </Descriptions.Item>
        )
      )}
    </Descriptions>
  );
};

ReportReviewDetail.propTypes = {
  detail: PropTypes.array.isRequired,
  completedBy: PropTypes.object.isRequired,
  date: PropTypes.number.isRequired,
};

export default ReportReviewDetail;
